import React from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from 'redux/Hook'
import { toggleFilterByProjectAndEngagementDialog } from 'redux/slices/FilterBuilder'
import FilterByProjectDialog from 'components/Participants/Filters/Project/ProjectDialog'

const FilterByProject = () => {
  const dispatch = useDispatch()

  // controlling the visibility of the modal from the global state
  const { showFilterByProjectAndEngagementDialog } = useAppSelector(
    (state) => state.filterBuilder,
  )

  const handleClose = () => dispatch(toggleFilterByProjectAndEngagementDialog())

  return (
    <>
      <FilterByProjectDialog
        open={showFilterByProjectAndEngagementDialog}
        onClose={handleClose}
      />
    </>
  )
}

export default FilterByProject
